export default __webpack_public_path__ + "d09329d8ccd7bdfe2fd9b953940613de.svg";